module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    style: (_vm.mainContainerStyle.mainStyle.confirmationApproveWithChanges)
  }, [_c('div', {
    staticClass: "width_full",
    style: (_vm.mainContainerStyle.mainStyle.tableButton)
  }, [(_vm.data.code === _vm.code.APPROVE_WITH_CHANGES) ? _c('h5', [_vm._v(_vm._s(_vm.code.APPROVE_WITH_CHANGES_TEXT))]) : (_vm.data.code === _vm.code.APPROVE_WITH_NO_CHANGES) ? _c('h5', [_vm._v("\n        " + _vm._s(_vm.code.NO_CHANGES_TEXT) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.data.headers && _vm.data.headers.length) ? _c('div', {
    attrs: {
      "id": "confirmationInnerDiv"
    }
  }, [_c('div', {
    staticClass: "center center-parent"
  }, [_c('div', {
    staticClass: "text-left inline-block",
    attrs: {
      "id": "selectedOffersHeaderContainer"
    }
  }, [_c('data-table', {
    attrs: {
      "data": _vm.data.headers,
      "styles": _vm.tableStyles.offersListHeaderStyles
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "inline-block scrollable",
    style: ({
      width: ((_vm.count * _vm.scrollableWidth) + "rem")
    })
  }, [_c('div', {
    staticClass: "inline-block",
    style: ({
      width: ((_vm.data.contents.length * _vm.scrollableChildrenWidth) + "rem")
    })
  }, _vm._l((_vm.data.contents), function(data) {
    return _c('div', {
      staticClass: "text-left inline-block",
      style: ({
        width: (_vm.scrollableChildrenWidth + "rem")
      })
    }, [_c('data-table', {
      attrs: {
        "data": data,
        "styles": _vm.tableStyles.offersListDataStyle
      }
    })], 1)
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin_bottom width_full",
    style: (_vm.mainContainerStyle.mainStyle.tableButton)
  }, [(_vm.data.code === _vm.code.APPROVE_WITH_CHANGES || _vm.data.code === _vm.code.APPROVE_WITH_NO_CHANGES || _vm.data.code === _vm.code.SET_ZONE) ? _c('h5', [_vm._v("\n        " + _vm._s(_vm.code.SUBMIT_TEXT) + "\n      ")]) : (_vm.data.code === _vm.code.REJECT_OFFER) ? _c('h5', [_vm._v(_vm._s(_vm.code.REJECT_TEXT))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "primary-green-bg width_8",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n        Cancel\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "primary-green-bg width_8",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n        Submit\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65203d12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-up/ConfirmationPopUp.vue
// module id = 372
// module chunks = 2